import { useState } from "react";
import { AddonsPropType } from "../../home/types";
import { useDispatch } from "react-redux";
import { removeAddon } from "../../cart/reducer";

type PropType = {
  currencySymbol: string;
  onAdd: (id: number) => void;
  addon: AddonsPropType;
  onIncrease: (id: number) => void;
  onDecrease: (id: number) => void;
};

const AddonCard = ({
  addon,
  onIncrease,
  onDecrease,
  onAdd,
  currencySymbol,
}: PropType) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);

  const onChecked = (id: any) => {
    setIsChecked(!isChecked);
    !isChecked ? onAdd(id) : dispatch(removeAddon(id));
  };
  return (
    <div className="md:pl-10">
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <label className="">
            <input
              type="checkbox"
              className="checkbox-input accent-primary"
              checked={isChecked}
              onChange={() => onChecked(addon.id)}
            />
          </label>
          <div className="text-[#727272] text-sm font-normal">
            {addon.addon_name}
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-[#727272] text-sm font-normal">
            +{currencySymbol} {addon.addon_price}
          </div>
          {/* Quantity */}
          {isChecked && (
            <div className="flex gap-3 items-center">
              <div
                className={`cursor-pointer w-6 h-6 rounded-full flex items-center justify-center text-white  ${
                  addon.quantity! > 1 ? "bg-primary" : "bg-[#E0E0E0]"
                }`}
                onClick={() => {
                  onDecrease(addon.id);
                }}
              >
                -
              </div>
              <div className="">{addon.quantity || 0} </div>
              <div
                className="cursor-pointer w-6 h-6 rounded-full flex items-center justify-center text-white bg-primary"
                onClick={() => onIncrease(addon.id)}
              >
                +
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddonCard;
